export const styles = {
  modalPaper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 640,
    width: 'calc(100% - 32px)',
    maxHeight: '90vh',
    overflowY: 'auto',
    p: 3,
    outline: 'none',
  },
  title: {
    mb: 1,
  },
  intro: {
    mb: 2,
    color: 'text.secondary',
  },
  section: {
    mb: 2,
  },
  sectionTitle: {
    fontWeight: 700,
    mb: 0.75,
    fontSize: '0.95rem',
  },
  sectionBody: {
    color: 'text.secondary',
    fontSize: '0.875rem',
    lineHeight: 1.55,
    mb: 0.5,
  },
  list: {
    m: 0,
    pl: 2.5,
    color: 'text.secondary',
    fontSize: '0.875rem',
    lineHeight: 1.55,
  },
  checkboxRow: {
    mt: 2,
    mb: 2,
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
};
